export const customTigger = (editor) => {
  // Component: Popup Trigger Button
  editor.Components.addType("popup-trigger-button", {
    extend: "button",
    model: {
      defaults: {
        tagName: "button",
        name: "Popup Trigger",
        attributes: {
          'data-gjs-highlightable': 'true', // 👈 highlightable in canvas
        },
        traits: [
          {
            type: "select",
            label: "Target Popup ID",
            name: "popupId",
            options: [], // will be populated dynamically
            changeProp: 1,
          },
        ],
        // content: "Open Popup",
        style: {
          "min-width": "50px",
          "min-height": "50px",
          // padding: "10px 20px",
          "background-color": "#ffff",
          //  // color: "white",
          border: "none",
          display: "inline-block",
          cursor: "pointer",
        },
        draggable: true,
        droppable: true,
        resizable: true,
      },

      init() {
        this.on("change:popupId", () => {
          const id = this.get("popupId");
          this.addAttributes({
            'data-popup-id': id,
          });
        });

        // 🔁 Refresh dropdown when selected
        editor.on("component:selected", (comp) => {

          if (comp === this) {
            const allIds = [];

            const walk = (comps) => {
              comps.each((child) => {
                const id = child.getAttributes()?.id;
                //  console.log(child.get("type"), "here")
                if (id && child.get("type") === "custom-popup") {
                  allIds.push(id);
                }
                if (child.components().length) walk(child.components());
              });
            };

            walk(editor.DomComponents.getComponents());

            // const popupIdTrait = this.get("traits").find((t) => t.name === "popupId");
            const popupIdTrait = this.getTrait("popupId");

            // console.log(popupIdTrait)


            if (popupIdTrait) {

              //popupIdTrait.options = allIds.map((id) => ({ id, name: id }));
              popupIdTrait.set("options", allIds.map((id) => ({ id, name: id })));

              // ✅ Force trait panel to refresh
              // const selected = editor.getSelected();
              // editor.select(null);
              // editor.select(selected);
              //  this.trigger("change:traits");
            }
          }
        });
      }

      // 🔄 Custom method to update popup list
      // updatePopupOptions() {
      //   debugger;
      //   const allIds = [];

      //   const walk = (comps) => {
      //     comps.each((comp) => {
      //       const id = comp.getAttributes()?.id;
      //       if (id && comp.get("type") === "custom-popup") {
      //         allIds.push(id);
      //       }
      //       if (comp.components().length) walk(comp.components());
      //     });
      //   };

      //   walk(editor.DomComponents.getComponents());

      //   const popupIdTrait = this.get("traits").find((t) => t.name === "popupId");

      //   if (popupIdTrait) {
      //     popupIdTrait.options = allIds.map((id) => ({ id, name: id }));
      //     this.trigger("change:traits");
      //   }
      // }

    },
  });


}

